module.exports = __webpack_public_path__ + "img/erik-mayer.c109b3f9.jpg";